<template>
  <div class="hpFooterWrap">
    <div class="hpFooterInner">
      <div>
        <!-- INFORMATION 섹션 -->
        <div class="hpFooter_contBox" :class="{ open: isSectionOpen('info') }">
          <p class="hpFooter_contBoxTit" @click="toggleSection('info')">Information <span v-if="!isDesktop" :class="getArrowClass('info')"></span></p>
          <ul class="hpFooter_contBoxInfo" v-if="isSectionOpen('info') || isDesktop">
            <li>상호 : N for U</li>
            <li>대표 : 정동석</li>
            <li>사업자등록번호 : 617-18-41032</li>
            <li>통신판매업번호 : 2015-부산해운-0393</li>
            <li>개인정보 관리 및 보호 책임 : 정동석</li>
          </ul>
        </div>

        <!-- ABOUT 섹션 -->
        <div class="hpFooter_contBox" :class="{ open: isSectionOpen('about') }">
          <p class="hpFooter_contBoxTit" @click="toggleSection('about')">About <span v-if="!isDesktop" :class="getArrowClass('about')"></span></p>
          <ul class="hpFooter_contBoxInfo" v-if="isSectionOpen('about') || isDesktop">
            <li><a href="/Company">회사소개</a></li>
            <li><a href="/Info?section=2">이용약관</a></li>
            <li><a href="/Info?section=3">개인정보취급방침</a></li>
          </ul>
        </div>
      </div>

      <div>
        <!-- CUSTOMER CARE 섹션 -->
        <div class="hpFooter_contBox" :class="{ open: isSectionOpen('customer') }">
          <p class="hpFooter_contBoxTit" @click="toggleSection('customer')">Customer Center <span v-if="!isDesktop" :class="getArrowClass('customer')"></span></p>
          <ul class="hpFooter_contBoxInfo" v-if="isSectionOpen('customer') || isDesktop">
            <li><em class="fB600">온라인 고객센터</em></li>
            <li>월~금 10:30 ~ 18:00</li>
            <li>주말, 공휴일 휴무</li>
          </ul>
        </div>

        <!-- CONTACT 섹션 -->
        <div class="hpFooter_contBox" :class="{ open: isSectionOpen('contact') }">
          <p class="hpFooter_contBoxTit" @click="toggleSection('contact')">Contact <span v-if="!isDesktop" :class="getArrowClass('contact')"></span></p>
          <ul class="hpFooter_contBoxInfo" v-if="isSectionOpen('contact') || isDesktop">
            <li>프로젝트 및 제안서 문의</li>
            <li><a href="mailto:nforuhome@gmail.com">nforuhome@gmail.com</a></li>
            <li><a href="tel:051-743-6147">051-743-6147</a></li>
          </ul>
        </div>
      </div>

      <div>
        <!-- SHOWROOM 섹션 -->
        <div class="hpFooter_contBox" :class="{ open: isSectionOpen('showroom') }">
          <p class="hpFooter_contBoxTit" @click="toggleSection('showroom')">Showroom <span v-if="!isDesktop" :class="getArrowClass('showroom')"></span></p>
          <ul class="hpFooter_contBoxInfo" v-if="isSectionOpen('showroom') || isDesktop">
            <li>엔포유 쇼룸</li>
            <li>월~일 10:00 ~ 19:00 (공휴일 정상영업)</li>
            <li><a href="tel:051-743-6147">전화 : 051-743-6147</a></li>
          </ul>
        </div>

        <!-- SHOWROOM 섹션 -->
        <div class="hpFooter_contBox" :class="{ open: isSectionOpen('department') }">
          <p class="hpFooter_contBoxTit" @click="toggleSection('department')">Department Store <span v-if="!isDesktop" :class="getArrowClass('department')"></span></p>
          <ul class="hpFooter_contBoxInfo" v-if="isSectionOpen('department') || isDesktop">
            <li>신세계백화점 센텀시티점 8층 까시나</li>
            <li>월~목 10:30 ~ 20:00</li>
            <li>금~일(공휴일) 10:30 ~ 20:30</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      openSections: {},
      isDesktop: window.innerWidth >= 900 // 데스크톱 여부 확인
    }
  },
  methods: {
    toggleSection (section) {
      this.$set(this.openSections, section, !this.openSections[section])
    },
    isSectionOpen (section) {
      return this.openSections[section]
    },
    getArrowClass (section) {
      return this.openSections[section] ? 'hpFooter_contBoxTit_arrowUp' : 'hpFooter_contBoxTit_arrowDown'
    },
    handleResize () {
      this.isDesktop = window.innerWidth >= 900
    }
  },
  mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Homepage/Section/Footer.vue